import React from 'react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { CalendarLayoutManagement } from '@components/features/calendar-layout/management/CalendarLayoutManagement';

/**
 * Admin view of the calendar layout models: authoring system-wide models, setting the system
 * default, and assigning models to any company or location.
 *
 * Customers reach the same screens, narrowed to their own company, from settings.
 */
const IndexPage: React.FC = () => {
  const { tr } = useTranslationLgs();

  return (
    <AdminLayout title={tr('CalendarLayout.pageTitle', 'Calendar card layouts')}>
      <CalendarLayoutManagement admin title={tr('CalendarLayout.pageTitle', 'Calendar card layouts')} />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(IndexPage);
